import template from './payroll.html';
import controller from './payroll.controller';

let payrollComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default payrollComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/payroll/payroll.component.js